import SocialIcon from "../components/icons/SocialIcon";
import SideAreaTitle from '../components/SideAreaTitle';
import { Fade, JackInTheBox } from "react-awesome-reveal";
import { useCallback, useEffect, useRef, useState } from "react";
import emailjs from "emailjs-com";

interface ConnectProps {
    isActive?: boolean;
}

const Connect = ({ isActive = false }: ConnectProps) => {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [error, setError] = useState(false);
    const [revealCycle, setRevealCycle] = useState(0);
    const revealTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const reset = useCallback(() => {
        setError(false)
        setIsSubmitted(false)
    }, [])
    useEffect(() => {
        if (!isActive) {
            reset();
            if (revealTimeoutRef.current) {
                clearTimeout(revealTimeoutRef.current);
                revealTimeoutRef.current = null;
            }
            return;
        }

        // Re-mount reveal components after side panel slide-in ends (1s in CSS)
        revealTimeoutRef.current = setTimeout(() => {
            setRevealCycle((prev) => prev + 1);
            revealTimeoutRef.current = null;
        }, 1050);

        return () => {
            if (revealTimeoutRef.current) {
                clearTimeout(revealTimeoutRef.current);
                revealTimeoutRef.current = null;
            }
        };
    }, [isActive, reset]);


    const [formData, setFormData] = useState({
        name: "",
        subject: "seroujkh",
        email: "",
        message: "",
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    let timeout
    const handleSubmit = (e) => {
        e.preventDefault();
        setError(false);
        clearTimeout(timeout)
        console.log("ERRR")

        // EmailJS configuration
        const serviceID = "service_hbu7u4o";
        const templateID = "template_qcq6oeh";
        const publicKey = "3nT41gX2gJNVdCvSM";
        setIsSubmitted(false);
        if (formData.email == '' || formData?.message == '' || formData?.subject == '' || formData?.name == '') {
            setError(true)
            return
        }
        emailjs
            .send(serviceID, templateID, formData, publicKey)
            .then(
                (response) => {
                    console.log("SUCCESS!", response.status, response.text);
                    setIsSubmitted(true);
                    timeout = setTimeout(() => {
                        setIsSubmitted(false)
                    }, 5000)
                    setFormData({ name: "", email: "", subject: "", message: "" });
                },
                (err) => {
                    console.error("FAILED...", err);
                    setError(true);
                }
            );
    };




    return (
        <div className={`col-lg-9 col-xl-7 fh-100 side-area-container connect-page${isSubmitted ? ' sent' : ''}`}>


            <div className="white_box"></div>
            <div className="box_container w-100  pos-z blue" >
                <SideAreaTitle title="Connect" colorClass="blue"
                />

                <div className="mt-3">
                    <SideAreaTitle title="Have a Project or an idea in mind?"
                        TitleTag="h2"
                        isCentered={true}
                        subtitle="Let's discuss how we can work together. Fell free to reach out sing the form below" />

                </div>
                <div className="row">
                    <div className="col-12">
                        <JackInTheBox key={`connect-form-${revealCycle}`} delay={50} triggerOnce fraction={0}>
                            <div className="connect-form">
                                <form className={`${isSubmitted ? ' sent' : ''} ${error ? 'error' : ''}`} onSubmit={handleSubmit}>
                                    <article className="letter">
                                        <div className="side bg-light">
                                            <p>
                                                <textarea name='message' placeholder='Message' value={formData?.message} onChange={handleChange} ></textarea>
                                            </p>
                                        </div>
                                        <div className="side bg-light">
                                        
                                            <p>
                                                <input type="text" name='name' value={formData?.name} placeholder='Name' onChange={handleChange} />
                                            </p>
                                            <p>
                                                <input type="text" name='email' placeholder='Email' value={formData?.email} onChange={handleChange} />
                                            </p>
                                            <p>
                                                <button id="sendLetter" >Send</button>
                                            </p>
                                        </div>
                                    </article>
                                    <div className="envelope front"></div>
                                    <div className="envelope back"></div>
                                </form>
                            </div>
                        </JackInTheBox>
                    </div>

                    <div className="col-lg-12 overflow-hiddden">
                        <Fade key={`connect-links-${revealCycle}`} delay={500} triggerOnce fraction={0}>
                            <div className="d-flex align-items-center mt-3 justify-content-center">
                                <SocialIcon platform="mail" link="mailto:seroujkh@hotmail.com" />
                                <a href="mailto:seroujkh@hotmail.com" rel="noreferrer" target="_blank" className="link_blue ml-3">seroujkh@hotmail.com</a>
                            </div>
                            <div className="d-flex align-items-center mt-3 justify-content-center social_icons_row position-relative">
                                <SocialIcon platform="instagram" link="https://www.instagram.com/seroujkhandjihanian/" />
                                <SocialIcon platform="linkedin" link="https://www.linkedin.com/in/serouj-khandjihanian-895997183/" />
                                <SocialIcon platform="twitter" link="https://x.com/seroujkh" />
                            </div>
                        </Fade>
                    </div>

                </div>
            </div>
        </div>

    )
}

export default Connect;
